import ModalComp from "themes/elements/Modal";
import ModalFooter from "../modalFooter";

function SubmitProjectArticle({ open, onSubmit, setOpen, loading, title }) {
  const handleSubmit = () => {
    onSubmit("publish");
  };
  return (
    <ModalComp
      title="Submit the article for approval?"
      footer={
        <ModalFooter
          handlePrimaryBtn={() => setOpen(false)}
          primaryBtnVariant="secondary"
          primaryBtnText="Cancel"
          secondaryBtnLoading={loading}
          handleSecondaryBtn={handleSubmit}
          secondaryBtnText="Submit"
        />
      }
      open={open}
      setOpen={setOpen}
    >
      You can no longer edit the content of this article while it awaits
      approval.
    </ModalComp>
  );
}

export default SubmitProjectArticle;
